var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMintSolid = function SvgMintSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 6.5v4.063c0 1.608-1.149 2.862-2.56 3.655C11.998 15.03 10.072 15.5 8 15.5c-2.072 0-3.998-.47-5.44-1.282C1.149 13.425 0 12.172 0 10.563V6.5C0 3.462 3.582 1 8 1s8 2.462 8 5.5ZM8 12c2.39 0 4.534-.72 6-1.862v.425c0 .565-.418 1.28-1.54 1.912C11.367 13.09 9.793 13.5 8 13.5s-3.368-.411-4.46-1.025C2.419 11.844 2 11.128 2 10.563v-.425C3.466 11.28 5.61 12 8 12Z",
    clipRule: "evenodd"
  })));
};
export default SvgMintSolid;